import { render, staticRenderFns } from "./NumberFilterSummary.vue?vue&type=template&id=64936e4c&scoped=true"
import script from "./NumberFilterSummary.vue?vue&type=script&lang=js"
export * from "./NumberFilterSummary.vue?vue&type=script&lang=js"
import style0 from "./NumberFilterSummary.vue?vue&type=style&index=0&id=64936e4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64936e4c",
  null
  
)

export default component.exports